import DistanceUnit from '@/common/enums/DistanceUnit.enum';

const distanceConversions = {
  [DistanceUnit.KILOMETER]: 0.001,
  [DistanceUnit.METER]: 1,
  [DistanceUnit.MILE]: 0.000621371,
  [DistanceUnit.FOOT]: 3.28084,
};

export default class UnitConverter {
  static convertDistance(value, from, to) {
    if (!distanceConversions[from]) {
      throw new Error('invalid from unit');
    }
    if (!distanceConversions[to]) {
      throw new Error('invalid to unit');
    }

    return (value * distanceConversions[to]) / distanceConversions[from];
  }
}
